const API_URL = process.env.NODE_ENV === 'development' ? '/api-merchant' : ''
import { request, get } from '@/utils/request'
import { getToken } from '@/utils/auth'
export const uploadImageToOss = API_URL + '/oss/uploadImgToOss'
/* 上传图片 */
export const uploadImageFile = data => request({
  url: '/oss/uploadImgToOss',
  method: 'POST',
  data: data,
  headers: {
    'Content-Type': 'multipart/form-data',
    ACCESSTOKEN: getToken()
  }
})
/* 上传图片 key上附带UserId */
export const uploadImageFileByUserId = data => request({
  url: '/oss/uploadImgToOssUserId',
  method: 'POST',
  data: data,
  headers: {
    'Content-Type': 'multipart/form-data',
    ACCESSTOKEN: getToken()
  }
})

export const getCosConfig = () => get('/cos')

export const getPresignDownloadUrl = (key) =>
  get('/get_presign_download_url', { key })


export const uploadImageFileAllow = data => request({
  url: '/login/uploadImgToOss',
  method: 'POST',
  data: data,
  headers: {
    'Content-Type': 'multipart/form-data',
  }
})

export const getPresignDownloadUrlAllow = (key) =>
  get('/login/get_presign_download_url', { key })




// WEBPACK FOOTER //
// ./src/api/upload.js